'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var throwErrorAsync = exports.throwErrorAsync = function throwErrorAsync(error) {
  setTimeout(function () {
    throw error;
  }, 0);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/utils/ThrowError.js
// module id = 487
// module chunks = 2 3